// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/ckpt/workspace/front_package_tools_online_正式_pro/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/user",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/UserLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "name": "login",
        "path": "/user/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/user/login'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__SecurityLayout' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/SecurityLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/gameSelect",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__GameSelect' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/GameSelect'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/AdminLayout'), loading: LoadingComponent})],
        "exact": true
      },
      {
        "name": "操作日志",
        "path": "/oplog",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__CommonContainer' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/CommonContainer'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/AdminLayout'), loading: LoadingComponent})],
        "routes": [
          {
            "name": "操作日志",
            "path": "/oplog",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Oplog' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Oplog'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/unity",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__CommonContainer' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/CommonContainer'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/AdminLayout'), loading: LoadingComponent})],
        "routes": [
          {
            "path": "/unity/menu",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Menu' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Menu'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/unity/people",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__UnityPeople' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/UnityPeople'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "字典配置",
            "path": "/unity/dicConfig",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__DicConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/DicConfig'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "KEY配置",
            "path": "/unity/keyConfig",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__KeyConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/KeyConfig'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "新建父游戏",
            "path": "/unity/gameConfig",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__GamesConfig__Parent__Config' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/GamesConfig/Parent/Config'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "游戏列表",
            "path": "/unity/listGame",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__ListGame' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/ListGame'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "防沉迷",
            "path": "/unity/anti-addiction",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Special__AntiAddiction' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Special/AntiAddiction'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "三方支付国家配置",
            "path": "/unity/countryConfig",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__countryConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/countryConfig'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/sdk",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/AdminLayout'), loading: LoadingComponent})],
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__CommonContainer' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/CommonContainer'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/sdk/appMarket",
            "name": "大渠道管理",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sdk__AppMarket' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Sdk/AppMarket'), loading: LoadingComponent}),
            "authority": "/sdk/appMarket",
            "exact": true
          },
          {
            "path": "/sdk/plugin",
            "name": "插件管理",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sdk__Plugin' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Sdk/Plugin'), loading: LoadingComponent}),
            "authority": "/sdk/plugin",
            "exact": true
          },
          {
            "name": "SDK管理",
            "path": "/sdk/plugin/sdkConfig",
            "hideInMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sdk__SDKConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Sdk/SDKConfig'), loading: LoadingComponent}),
            "authority": "/sdk/plugin",
            "exact": true
          },
          {
            "path": "/sdk/channel",
            "name": "渠道商管理",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sdk__Channel' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Sdk/Channel'), loading: LoadingComponent}),
            "authority": "/sdk/channel",
            "exact": true
          },
          {
            "path": "/sdk/channel/business/addEdit",
            "name": "渠道商编辑",
            "isNotKeep": true,
            "hideInMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sdk__Channel__Business__addEdit' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Sdk/Channel/Business/addEdit'), loading: LoadingComponent}),
            "authority": "/sdk/channel",
            "exact": true
          },
          {
            "path": "/sdk/channel/sdk",
            "name": "渠道商版本管理",
            "hideInMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sdk__Channel__SDK' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Sdk/Channel/SDK'), loading: LoadingComponent}),
            "authority": "/sdk/channel",
            "exact": true
          },
          {
            "path": "/sdk/packageTool",
            "name": "打包工具",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sdk__PackageTool' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Sdk/PackageTool'), loading: LoadingComponent}),
            "authority": "/sdk/packageTool",
            "exact": true
          }
        ]
      },
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/layouts/BasicLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/welcome",
            "name": "welcome",
            "icon": "smile",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Welcome' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Welcome'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "字典配置",
            "path": "/dic",
            "authority": "/dic",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "通用配置",
                "path": "/dic/commonConfig",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__CommonConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/CommonConfig'), loading: LoadingComponent}),
                "authority": "/dic/commonConfig",
                "exact": true
              },
              {
                "name": "新增配置",
                "path": "/dic/commonConfig/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__CommonConfig__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/CommonConfig/Create'), loading: LoadingComponent}),
                "authority": "/dic/commonConfig",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              }
            ]
          },
          {
            "name": "订单管理",
            "path": "/order",
            "authority": "/order",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "订单流水",
                "path": "/order/flow",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__Flow' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Order/Flow'), loading: LoadingComponent}),
                "authority": "/order/flow",
                "exact": true
              },
              {
                "name": "补单记录",
                "path": "/order/record",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__Record' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Order/Record'), loading: LoadingComponent}),
                "authority": "/order/record",
                "exact": true
              },
              {
                "name": "测试订单",
                "path": "/order/check",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__Check' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Order/Check'), loading: LoadingComponent}),
                "authority": "/order/check",
                "exact": true
              },
              {
                "name": "退款订单",
                "path": "/order/refund",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__Refund' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Order/Refund'), loading: LoadingComponent}),
                "authority": "/order/refund",
                "exact": true
              }
            ]
          },
          {
            "name": "OG订单管理",
            "path": "/ogorder",
            "authority": "/ogorder",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "订单流水",
                "path": "/ogorder/flow",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OgOrder__Flow' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/OgOrder/Flow'), loading: LoadingComponent}),
                "authority": "/ogorder/flow",
                "exact": true
              },
              {
                "name": "补单记录",
                "path": "/ogorder/record",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OgOrder__Record' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/OgOrder/Record'), loading: LoadingComponent}),
                "authority": "/ogorder/record",
                "exact": true
              },
              {
                "name": "测试订单",
                "path": "/ogorder/check",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OgOrder__Check' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/OgOrder/Check'), loading: LoadingComponent}),
                "authority": "/ogorder/check",
                "exact": true
              },
              {
                "name": "退款订单",
                "path": "/ogorder/refund",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OgOrder__Refund' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/OgOrder/Refund'), loading: LoadingComponent}),
                "authority": "/ogorder/refund",
                "exact": true
              },
              {
                "name": "开票管理",
                "path": "/ogorder/bill",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OgOrder__Bill' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/OgOrder/Bill'), loading: LoadingComponent}),
                "authority": "/ogorder/bill",
                "exact": true
              },
              {
                "name": "退款封禁",
                "path": "/ogorder/refundBan",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OgOrder__RefundBan' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/OgOrder/RefundBan'), loading: LoadingComponent}),
                "authority": "/ogorder/refundBan",
                "exact": true
              },
              {
                "name": "大额转账",
                "path": "/ogorder/largeTransOrder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OgOrder__LargeTransOrder' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/OgOrder/LargeTransOrder'), loading: LoadingComponent}),
                "authority": "/ogorder/largeTransOrder",
                "exact": true
              }
            ]
          },
          {
            "name": "游戏运营",
            "path": "/operate",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "authority": "/operate",
            "routes": [
              {
                "name": "用户角色生日",
                "path": "/operate/userBirthday",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__UserBirthday' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/UserBirthday'), loading: LoadingComponent}),
                "authority": "/operate/userBirthday",
                "exact": true
              },
              {
                "name": "短信配置",
                "path": "/operate/messageConfig",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__MessageConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/MessageConfig'), loading: LoadingComponent}),
                "authority": "/operate/messageConfig",
                "exact": true
              },
              {
                "name": "封禁管理",
                "path": "/operate/stopConfig",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__StopConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/StopConfig'), loading: LoadingComponent}),
                "authority": "/operate/stopConfig",
                "exact": true
              },
              {
                "name": "强更配置",
                "path": "/operate/updateConfig",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__UpdateConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/UpdateConfig'), loading: LoadingComponent}),
                "authority": "/operate/updateConfig",
                "exact": true
              },
              {
                "path": "/operate/accountLogout",
                "name": "账号注销",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__AccountLogout' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/AccountLogout'), loading: LoadingComponent}),
                "authority": "/operate/accountLogout",
                "exact": true
              },
              {
                "path": "/operate/sdkAccountManagement",
                "name": "SDK账号管理（OG）",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__SdkAccountManagement' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/SdkAccountManagement'), loading: LoadingComponent}),
                "authority": "/operate/sdkAccountManagement",
                "exact": true
              },
              {
                "path": "/operate/sdkAccountOverseas",
                "name": "SDK账号管理（海外）",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__SdkAccountOverseas' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/SdkAccountOverseas'), loading: LoadingComponent}),
                "authority": "/operate/sdkAccountOverseas",
                "exact": true
              },
              {
                "path": "/operate/accountManagement",
                "name": "SDK账号管理",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sdk__AccountManagement' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Sdk/AccountManagement'), loading: LoadingComponent}),
                "authority": "/operate/accountManagement",
                "exact": true
              },
              {
                "name": "新增短信配置",
                "path": "/operate/messageConfig/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__MessageConfig__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/MessageConfig/Create'), loading: LoadingComponent}),
                "authority": "/operate/messageConfig",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "新增禁封配置",
                "path": "/operate/stopConfig/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__StopConfig__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/StopConfig/Create'), loading: LoadingComponent}),
                "authority": "/operate/stopConfig",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "新增强更配置",
                "path": "/operate/updateConfig/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dic__UpdateConfig__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Dic/UpdateConfig/Create'), loading: LoadingComponent}),
                "authority": "/operate/updateConfig",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "事件查询",
                "path": "/operate/events",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__Events' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/Events'), loading: LoadingComponent}),
                "authority": "/operate/events",
                "exact": true
              },
              {
                "name": "会话详情",
                "path": "/operate/Events/conversation",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__Events__Conversation' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/Events/Conversation'), loading: LoadingComponent}),
                "authority": "/operate/updateConfig",
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "事件管理",
                "path": "/operate/eventsManage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__EventsManage' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/EventsManage'), loading: LoadingComponent}),
                "authority": "/operate/eventsManage",
                "exact": true
              },
              {
                "name": "广告配置",
                "path": "/operate/adConfiguration",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__AdConfiguration' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/AdConfiguration'), loading: LoadingComponent}),
                "authority": "/operate/adConfiguration",
                "exact": true
              },
              {
                "name": "海报弹窗",
                "path": "/operate/posterPop",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__PosterPop' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/PosterPop'), loading: LoadingComponent}),
                "authority": "/operate/posterPop",
                "exact": true
              },
              {
                "name": "海报弹窗编辑",
                "path": "/operate/posterPop/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__PosterPop__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/PosterPop/Create'), loading: LoadingComponent}),
                "authority": "/operate/posterPop",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "path": "/operate/tipManagement",
                "name": "提示语管理",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__TipManagement' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/TipManagement'), loading: LoadingComponent}),
                "authority": "/operate/tipManagement",
                "exact": true
              },
              {
                "name": "提示语管理",
                "path": "/operate/tipManagement/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__TipManagement__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/TipManagement/Create'), loading: LoadingComponent}),
                "authority": "/operate/tipManagement",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "用户账号迁移",
                "path": "/operate/userAccountMigration",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Operation__UserAccountMigration' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Operation/UserAccountMigration'), loading: LoadingComponent}),
                "authority": "/operate/userAccountMigration",
                "exact": true
              }
            ]
          },
          {
            "name": "支付管理",
            "path": "/pay",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "authority": "/pay",
            "routes": [
              {
                "name": "支付配置",
                "path": "/pay/payConfig",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Pay__PayConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Pay/PayConfig'), loading: LoadingComponent}),
                "authority": "/pay/payConfig",
                "exact": true
              },
              {
                "name": "支付列表",
                "path": "/pay/payList",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Pay__PayList' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Pay/PayList'), loading: LoadingComponent}),
                "authority": "/pay/payList",
                "exact": true
              },
              {
                "name": "计费点配置",
                "path": "/pay/billingPoint",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Pay__BillingPoint' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Pay/BillingPoint'), loading: LoadingComponent}),
                "authority": "/pay/billingPoint",
                "exact": true
              },
              {
                "name": "新建计费点配置",
                "path": "/pay/billingPoint/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Pay__BillingPoint__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Pay/BillingPoint/Create'), loading: LoadingComponent}),
                "authority": "/pay/billingPoint",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "新增配置",
                "path": "/pay/payList/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Pay__PayList__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Pay/PayList/Create'), loading: LoadingComponent}),
                "authority": "/pay/payList",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "新增支付配置",
                "path": "/pay/payConfig/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Pay__PayConfig__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Pay/PayConfig/Create'), loading: LoadingComponent}),
                "authority": "/pay/payConfig",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "多通道第三方支付配置",
                "path": "/pay/thirdParty",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Pay__ThirdParty' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Pay/ThirdParty'), loading: LoadingComponent}),
                "authority": "/pay/thirdParty",
                "exact": true
              },
              {
                "name": "新增第三方支付配置",
                "path": "/pay/thirdParty/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Pay__ThirdParty__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Pay/ThirdParty/Create'), loading: LoadingComponent}),
                "authority": "/pay/thirdParty/create",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              }
            ]
          },
          {
            "name": "配置管理",
            "path": "/setting",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "authority": "/setting",
            "routes": [
              {
                "name": "游戏配置",
                "path": "/setting/gamesConfig",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__GamesConfig__Parent' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/GamesConfig/Parent'), loading: LoadingComponent}),
                "authority": "/setting/gamesConfig",
                "exact": true
              },
              {
                "path": "/setting/gamesConfig/config",
                "name": "父游戏编辑",
                "hideInMenu": true,
                "isNotKeep": true,
                "authority": "/setting/gamesConfig",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__GamesConfig__Parent__Config' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/GamesConfig/Parent/Config'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/setting/gamesConfig/child",
                "name": "子游戏",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__GamesConfig__Child' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/GamesConfig/Child'), loading: LoadingComponent}),
                "authority": "/setting/gamesConfig",
                "exact": true
              },
              {
                "name": "线路",
                "path": "/setting/gamesConfig/line",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__GamesConfig__Line' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/GamesConfig/Line'), loading: LoadingComponent}),
                "authority": "/setting/gamesConfig",
                "exact": true
              },
              {
                "name": "运营主体",
                "path": "/setting/operation",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__Operation' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/Operation'), loading: LoadingComponent}),
                "authority": "/setting/operation",
                "exact": true
              },
              {
                "name": "协议列表",
                "path": "/setting/operation/protocol",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__Operation__Protocol' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/Operation/Protocol'), loading: LoadingComponent}),
                "authority": "/setting/operation",
                "exact": true
              },
              {
                "name": "短信列表",
                "path": "/setting/operation/smsList",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__Operation__SmsList' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/Operation/SmsList'), loading: LoadingComponent}),
                "authority": "/setting/operation",
                "exact": true
              },
              {
                "name": "协议配置",
                "path": "/setting/operation/protocol/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__Operation__Protocol__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/Operation/Protocol/Create'), loading: LoadingComponent}),
                "authority": "/setting/operation",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "协议配置",
                "path": "/setting/operation/protocol/createOverseas",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__Operation__Protocol__Create__overseas' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/Operation/Protocol/Create/overseas'), loading: LoadingComponent}),
                "authority": "/setting/operation",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "项目管理",
                "path": "/setting/project",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__Project' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/Project'), loading: LoadingComponent}),
                "authority": "/setting/project",
                "exact": true
              },
              {
                "name": "接口信息",
                "path": "/setting/interfaceInfo",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setting__InterfaceInfo' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Setting/InterfaceInfo'), loading: LoadingComponent}),
                "hideInMenu": true,
                "isNotKeep": true,
                "authority": "/setting/operation",
                "exact": true
              }
            ]
          },
          {
            "name": "线上打包工具",
            "path": "/package",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "authority": "/package",
            "routes": [
              {
                "name": "打包工具",
                "path": "/package/manager",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Package__Manager' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Package/Manager'), loading: LoadingComponent}),
                "authority": "/package/manager",
                "exact": true
              },
              {
                "name": "任务列表",
                "path": "/package/task",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Package__Task' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Package/Task'), loading: LoadingComponent}),
                "authority": "/package/task",
                "exact": true
              },
              {
                "name": "机器管理",
                "path": "/package/machine",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Package__Machine' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Package/Machine'), loading: LoadingComponent}),
                "authority": "/package/machine",
                "exact": true
              },
              {
                "name": "打包统计",
                "path": "/package/packingStatistics",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Package__PackingStatistics' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Package/PackingStatistics'), loading: LoadingComponent}),
                "authority": "/package/packingStatistics",
                "exact": true
              },
              {
                "name": "包体自检",
                "path": "/package/checkTask",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Package__CheckTask' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Package/CheckTask'), loading: LoadingComponent}),
                "authority": "/package/checkTask",
                "exact": true
              },
              {
                "name": "包体自检详情",
                "path": "/package/checkTask/details",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Package__CheckTask__details' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Package/CheckTask/details'), loading: LoadingComponent}),
                "authority": "/package/checkTask",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "包体自检参数详情",
                "path": "/package/checkTask/detailsJson",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Package__CheckTask__detailsJson' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Package/CheckTask/detailsJson'), loading: LoadingComponent}),
                "authority": "/package/checkTask",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              }
            ]
          },
          {
            "name": "特殊配置",
            "path": "/special",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "authority": "/special",
            "routes": [
              {
                "path": "/special/channelIntercommu",
                "name": "渠道互通",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Special__ChannelIntercommu' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Special/ChannelIntercommu'), loading: LoadingComponent}),
                "authority": "/special/channelIntercommu",
                "exact": true
              },
              {
                "path": "/special/cutPay",
                "name": "切支付",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Special__CutPay' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Special/CutPay'), loading: LoadingComponent}),
                "authority": "/special/cutPay",
                "exact": true
              },
              {
                "name": "新增配置",
                "path": "/special/cutPay/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Special__CutPay__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Special/CutPay/Create'), loading: LoadingComponent}),
                "authority": "/special/cutPay",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "账号监控",
                "path": "/special/monitor",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Special__Monitor' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Special/Monitor'), loading: LoadingComponent}),
                "authority": "/special/monitor",
                "exact": true
              },
              {
                "name": "新增账号监控",
                "path": "/special/monitor/create",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Special__Monitor__Create' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Special/Monitor/Create'), loading: LoadingComponent}),
                "authority": "/special/monitor",
                "hideInMenu": true,
                "isNotKeep": true,
                "exact": true
              },
              {
                "path": "/special/rebind-user",
                "name": "角色重绑定",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Special__RebindUser' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Special/RebindUser'), loading: LoadingComponent}),
                "authority": "/special/rebind-user",
                "exact": true
              },
              {
                "path": "/special/anti-addiction",
                "name": "防沉迷",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Special__AntiAddiction' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Special/AntiAddiction'), loading: LoadingComponent}),
                "authority": "/special/anti-addiction",
                "exact": true
              }
            ]
          },
          {
            "name": "自检平台",
            "path": "/check",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "authority": "/check",
            "routes": [
              {
                "path": "/check/joinup",
                "name": "接入自检平台",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SelfCheck__JoinUp' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/SelfCheck/JoinUp'), loading: LoadingComponent}),
                "authority": "/check/joinup",
                "exact": true
              },
              {
                "path": "/check/configuration",
                "name": "自检配置",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SelfCheck__Configuration' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/SelfCheck/Configuration'), loading: LoadingComponent}),
                "authority": "/check/configuration",
                "exact": true
              },
              {
                "name": "详情",
                "path": "/check/joinup/detail",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SelfCheck__Detail' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/SelfCheck/Detail'), loading: LoadingComponent}),
                "authority": "/check/joinup",
                "exact": true
              },
              {
                "name": "配置定义",
                "path": "/check/configuration/setConfig",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SelfCheck__SetConfig' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/SelfCheck/SetConfig'), loading: LoadingComponent}),
                "authority": "/check/configuration",
                "exact": true
              }
            ]
          },
          {
            "name": "个人页",
            "path": "/person",
            "hideInMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Person__Setting' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Person/Setting'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "权限管理",
            "path": "/access",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "authority": "/access",
            "routes": [
              {
                "path": "/access/role",
                "name": "角色管理",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Access__Role' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Access/Role'), loading: LoadingComponent}),
                "authority": "/access/role",
                "exact": true
              },
              {
                "path": "/access/people",
                "name": "人员管理",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Access__People' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Access/People'), loading: LoadingComponent}),
                "authority": "/access/people",
                "exact": true
              },
              {
                "name": "新建角色",
                "path": "/access/roleform",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Access__Role__roleform' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Access/Role/roleform'), loading: LoadingComponent}),
                "authority": "/access/people",
                "isNotKeep": true,
                "exact": true
              },
              {
                "name": "权限组管理",
                "path": "/access/rightGroup",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Access__RightGroup' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/Access/RightGroup'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "用户统计",
            "path": "/userStatistics",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "authority": "/userStatistics",
            "routes": [
              {
                "path": "/userStatistics/integral",
                "name": "角色管理",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__userStatistics__integral' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/userStatistics/integral'), loading: LoadingComponent}),
                "authority": "/userStatistics/integral",
                "exact": true
              }
            ]
          },
          {
            "name": "充值中心",
            "path": "/rechargeCenter",
            "authority": "/rechargeCenter",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__KeepAliveLayout' */'@/layouts/KeepAliveLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "优惠券",
                "path": "/rechargeCenter/coupon",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RechargeCenter__Coupon' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/RechargeCenter/Coupon'), loading: LoadingComponent}),
                "authority": "/rechargeCenter/coupon",
                "exact": true
              },
              {
                "name": "页面功能",
                "path": "/rechargeCenter/pageFunction",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RechargeCenter__PageFunction' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/RechargeCenter/PageFunction'), loading: LoadingComponent}),
                "authority": "/rechargeCenter/pageFunction",
                "exact": true
              },
              {
                "name": "优惠券领取记录",
                "path": "/rechargeCenter/couponRecord",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RechargeCenter__CouponRecord' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/RechargeCenter/CouponRecord'), loading: LoadingComponent}),
                "authority": "/rechargeCenter/couponRecord",
                "exact": true
              }
            ]
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/ckpt/workspace/front_package_tools_online_正式_pro/src/pages/404'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
